import { render } from "./modal_patients_pending.vue?vue&type=template&id=2e17e6a8"
import script from "./modal_patients_pending.vue?vue&type=script&lang=js"
export * from "./modal_patients_pending.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__